<script>
    import { createEventDispatcher } from 'svelte';
    import { ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'sveltestrap';

    export let checked;
    export let disabled = false;
    export let savedBlocks;

    const dispatch = createEventDispatcher();

    function getChecked() {
        let list = Array();
        for (var i in checked)
            if (checked[i] == "success")
                list.push(i);
        return list;
    }

    function saveToBlock(block) {
        let list = getChecked().map(Number);
        block.block.push(...list);
        dispatch('patch', block);
    }

    $: reallyDisabled = disabled || !savedBlocks.length;
    $: classes = reallyDisabled ? "disabled" : "";
</script>

<ButtonDropdown>
    <DropdownToggle color="primary" disabled={reallyDisabled} class={classes} caret>Add to</DropdownToggle>
    <DropdownMenu>
        {#each savedBlocks as block}
            <DropdownItem on:click={() => saveToBlock(block)}>{block.name}</DropdownItem>
        {/each}
    </DropdownMenu>
</ButtonDropdown>

<style>
</style>